import moment from 'moment'

export const buildCommunityYearRangeFunctions = (createdAt) => {
  const currentYear = moment().year()
  const createdMoment = moment(createdAt)
  const createdYear = createdMoment.year()
  const firstYear = Math.min(currentYear, createdYear)
  const ranges = {}

  for (let year = currentYear; year >= firstYear; year -= 1) {
    const yearValue = year
    const label = yearValue === currentYear
      ? `This Year (${yearValue})`
      : yearValue === currentYear - 1
        ? `Last Year (${yearValue})`
        : `${yearValue}`

    ranges[yearValue] = {
      textFunc: () => label,
      valueFunc: () => {
        const startOfYear = moment()
          .year(yearValue)
          .startOf('year')
        const endOfYear = moment()
          .year(yearValue)
          .endOf('year')

        const startDate = yearValue === createdYear && createdMoment.isAfter(startOfYear)
          ? createdMoment.clone().toDate()
          : startOfYear.toDate()

        return {
          startDate,
          endDate: endOfYear.toDate(),
        }
      },
    }
  }

  return ranges
}
